export default __webpack_public_path__ + "static/media/Seegrid.da707191.png";